/**
 * Service for sorting organizations returned from a search on the Org Impersonation page
 */

/**
 * Sorts a list of organization objects based on params given
 * @param {string} sortBy - The value of the sortBy select field on the orgImpersonationPage
 * @param {array} orgs - The list of organization objects found in the search
 *
 * @returns {array} - Returns an array of objects sorted by the params given
 */
export default function sortOrgsList(sortBy, orgs) {
  const sliceIndex = sortBy.match(/Asc|Desc/).index;
  const [orderBy, order] = [sortBy.slice(0, sliceIndex), sortBy.slice(sliceIndex)];
  const desc = (a, b) => {
    if (b[orderBy].toLowerCase() < a[orderBy].toLowerCase()) return -1;
    if (b[orderBy].toLowerCase() > a[orderBy].toLowerCase()) return 1;
    return 0;
  };
  const getSorting = () => (order === 'Desc' ? (a, b) => desc(a, b) : (a, b) => -desc(a, b));

  return orgs.sort(getSorting(orderBy, order));
}
